
// PRESTATIONS
export const GET_PRESTATIONS = "/prestations";
export const ADD_NEW_PRESTATION = "/prestations";
export const UPDATE_PRESTATION = "/prestations";
export const DELETE_PRESTATION = "/prestations";


